import styled from 'styled-components';
import PropTypes from 'prop-types';
import themeColors from '../assets/styles/themeColors';

const LinkStyled = styled.a`
  color: ${(props) =>
    props.color ? `${props.color}` : `${themeColors.colorLink}`};
  ${({ editStyle }) => editStyle && 'font-size: 0.9rem;'}
  text-decoration: none;
  font-weight: 600;
  margin-top: ${(props) => (props.mt ? `${props.mt}px` : 0)};
  margin-bottom: ${(props) => (props.mb ? `${props.mt}px` : 0)};
  text-align: ${(props) => (props.textAlign ? `${props.textAlign}` : 'center')};
  &:hover {
    text-decoration: ${(props) =>
      props.hoverTextDecoration ? `${props.hoverTextDecoration}` : 'none'};
  }
`;

const Link = ({ title, onClick, href, editStyle, ...props }) => {
  const linkProps = {
    ...(href && {
      href,
    }),
    ...(onClick && {
      onClick: (e) => {
        e.preventDefault();
        onClick?.();
      },
    }),
  };

  return (
    <LinkStyled {...linkProps} {...props} editStyle={editStyle}>
      {title}
    </LinkStyled>
  );
};

Link.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  href: PropTypes.string,
  editStyle: PropTypes.bool,
};

export default Link;
